import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export const SliderButton = ({ type = 'button', icon, disabled, ...props }) => {
    return (_jsx(Root, { type: type, disabled: disabled, ...props, children: icon }));
};
const Root = styled.button `
  all: unset;
  color: ${(props) => props.theme.color.gray2[100]};

  display: inline-block;
  justify-content: center;
  cursor: pointer;

  padding: 0 25px;

  border-radius: 10px;
  font-weight: 500;
  line-height: 1;
  display: flex;
  gap: 5px;
  align-items: center;
  transition: all 100ms ease-in;

  padding: 0;
  width: 30px;
  height: 170px;

  &:hover:not(:disabled) {
    color: ${(props) => props.theme.color.white[100]};
    background: ${(props) => props.theme.color.black2[100]};
  }

  &:disabled {
    color: ${(props) => props.theme.color.gray2};
    opacity: 0.5;
  }
`;
//# sourceMappingURL=slider-button.js.map